<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <div class="term-title">
        <app-page-header
          title="Termo de aceitação"
          :subtitle="term.title"
        ></app-page-header>
      </div>
      <div class="img">
        <img src="@/assets/img/logo.svg" alt="Logo Venda e Ganhe" />
      </div>
    </div>
    <div class="modal-card-body">
      <div v-html="term.text"></div>
    </div>
    <button v-app-button @click="acceptTerm()">Aceitar termo</button>
  </div>
</template>

<script>
import TermVerificationService from '@/services/term-verification.service';

export default {
  name: 'app-modal',
  data: () => {
    return {
      term: {},
    };
  },
  methods: {
    acceptTerm() {
      TermVerificationService.postAccept().then(() => {
        this.toastify('Termo aceito com sucesso!');
        this.$parent.close();
      });
    },
    loadTerm() {
      TermVerificationService.getTerm().then(
        ({ data: term }) => (this.term = term)
      );
    },
  },
  mounted() {
    this.loadTerm();
  },
};
</script>

<style lang="scss">
.modal-card {
  button {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .term-title {
    width: 60%;
  }

  .img {
    position: relative;
    top: -10px;
  }
}
</style>
